module.exports = __webpack_public_path__ + "static/img/15.872d68eb.jpg";